import {
  AuthenticateInput,
  ContactPointInput,
  CreateCustomerInput,
  CreateFreightDeliveryInput,
  CreateLogisticsInput,
  CreateRequestForQuotationInput,
  PlaceInput,
  PostalAddressInput,
} from '#/__generated__/graphql/graphql';

export const CONTACT_POINT_INITIAL_VALUES: ContactPointInput = {
  email: '',
  name: '',
  telephone: '+60', // TODO: Add selection of country code and remove the hardcode
};

export const POSTAL_ADDRESS_INITIAL_VALUES: PostalAddressInput = {
  addressCountry: 'MY',
  addressLocality: '',
  addressRegion: '',
  postalCode: '',
  streetAddress: '',
};

export const PLACE_INITIAL_VALUES: PlaceInput = {
  address: POSTAL_ADDRESS_INITIAL_VALUES,
};

export const ORGANIZATION_INITIAL_VALUES = {
  address: POSTAL_ADDRESS_INITIAL_VALUES,
  areasServed: [],
  companyNumber: '',
  contactPoints: [CONTACT_POINT_INITIAL_VALUES, CONTACT_POINT_INITIAL_VALUES],
  description: '',
  name: '',
  referral: '',
  telephone: '+60',
};

export const CUSTOMER_INITIAL_VALUES: CreateCustomerInput = {
  ...ORGANIZATION_INITIAL_VALUES,
  businessCategoryId: '',
  cargoDetails: '',
  otherBusinessCategory: '',
  preferredContainerPacking: undefined,
};

export const LOGISTICS_INITIAL_VALUES: CreateLogisticsInput & {
  $offers?: { vehicleName: string }[];
} = {
  ...ORGANIZATION_INITIAL_VALUES,
  offers: [],
};

export const RFQ_INITIAL_VALUES: CreateRequestForQuotationInput = {
  cargoDetails: {
    cargoDimensions: {
      height: { unitCode: 'CMT', value: 0 },
      length: { unitCode: 'CMT', value: 0 },
      width: { unitCode: 'CMT', value: 0 },
    },
    cargoWeight: { unitCode: '', value: 0 },
    description: '',
  },
  deliveryTime: '',
  insuranceIncluded: false,
  note: '',
  pickupTime: '',
  preferredVehicle: { name: '' },
  routeLegs: [
    {
      endContactPoint: {
        ...CONTACT_POINT_INITIAL_VALUES,
        contactType: '',
      },
      endLocation: {
        address: POSTAL_ADDRESS_INITIAL_VALUES,
      },
      startContactPoint: {
        ...CONTACT_POINT_INITIAL_VALUES,
        contactType: '',
      },
      startLocation: {
        address: POSTAL_ADDRESS_INITIAL_VALUES,
      },
    },
  ],
};

export const AUTHENTICATE_INITIAL_VALUES: AuthenticateInput & { rememberMe: boolean } = {
  password: '',
  rememberMe: false,
  username: '',
};

export const FORGOT_PASSWORD_INITIAL_VALUES = {
  username: '',
};

export const FREIGHT_DELIVERY_INITIAL_VALUES: CreateFreightDeliveryInput = {
  deliveryAddress: POSTAL_ADDRESS_INITIAL_VALUES,
  driver: '',
  driverTelephone: '+60',
  originAddress: POSTAL_ADDRESS_INITIAL_VALUES,
  partOfOrderId: '',
  vehicle: { name: '' },
  vehicleRegistrationPlate: '',
};

export const CREATE_USER_INITIAL_VALUES = {
  customerId: '',
  email: '',
  logisticsId: '',
  manageUserCode: '',
  password: '',
  roles: ['Um9sZToz'], // Um9sZToz = AGENT
  userId: '',
  username: '',
};

export const ORDER_CANCELLATION_INITIAL_VALUES = {
  remark: '',
  selection: '',
};

export const RESET_PASSWORD_INITIAL_VALUES = {
  confirmPassword: '',
  password: '',
};
